import { Input } from "@ht/components";
import { ChangeEvent, FC } from "react";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import SearchIcon from "@ht/shared/fonts/deos-pis/search";
import CloseIcon from "@ht/shared/fonts/deos-pis/close";
import { TInput } from "@ht/components/src/forms/form-elements/types";

interface Props {
    value?: string;
    name: string;
    placeHolder?: string;
    onChange?: (e: ChangeEvent<TInput>) => void;
    onClear?: () => void;
    onEnter?: () => void;
    isDisabled?: boolean;
    className?: string;
}

export const SearchBox: FC<Props> = ({
    value,
    name,
    onChange,
    onClear,
    onEnter,
    placeHolder = "Search...",
    className,
    isDisabled
}) => {
    return (
        <div className="relative flex">
            {onClear && value != "" ?
                <button onClick={onClear} onKeyDown={() => { }} tabIndex={-1} className="absolute text-gray-400 h-4 w-4 top-1/2 -translate-y-1/2 left-[12px]">
                    <CloseIcon className="h-4 w-4"/> 
                </button>
                :
                <SearchIcon className="absolute text-gray-400 h-4 w-4 top-1/2 -translate-y-1/2 left-[12px]" />

            }

            <Input
                className={twMerge(
                    clsx(
                        "w-full rounded-md border-none bg-gray-100 py-2 pl-[34px] pr-3 font-thin text-gray-700 placeholder-gray-400 outline-none",
                        className
                    )
                )}
                id={name}
                name={name}
                placeholder={placeHolder}
                value={value}
                onChange={onChange}
                onKeyDown={(e) => {
                    if (e.key === 'Enter')
                        if (onEnter)
                            onEnter()
                }}
                disabled={isDisabled}
            />

        </div>
    );
};
